import { ApiResult } from '@/enums';
import { GraphApiRootError } from './graphApiRootError';

export class GraphApiResult<T> {
	public result: ApiResult = ApiResult.UnknownError;
	public value: T | null = null;
	public error: GraphApiRootError | null = null;
}
